import { useTranslation } from '@/i18n/useTranslation';

const RADIUS = 80;
const CENTER_X = 100;
const CENTER_Y = 100;

function arc(fraction: number) {
  const angle = Math.PI * (1 - fraction);
  const x = CENTER_X + RADIUS * Math.cos(angle);
  const y = CENTER_Y - RADIUS * Math.sin(angle);
  return `M ${CENTER_X - RADIUS} ${CENTER_Y} A ${RADIUS} ${RADIUS} 0 0 1 ${x} ${y}`;
}

export function CorrectionGauge({ count, target }: { count: number; target: number }) {
  const { locale, t } = useTranslation();
  const fraction = target > 0 ? Math.min(count / target, 1) : 0;
  const percent = target > 0 ? Math.round((count / target) * 100) : 0;
  const text = t('{count} of {target} defects corrected ({percent}%)', {
    count: count.toLocaleString(locale),
    target: target.toLocaleString(locale),
    percent: percent.toLocaleString(locale),
  });
  return (
    <div role="img" aria-label={text} style={{ maxWidth: 320 }}>
      <svg viewBox="0 0 200 120" width="100%" aria-hidden="true">
        <path d={arc(1)} fill="none" stroke="#dbe3e1" strokeWidth={16} strokeLinecap="round" />
        {fraction > 0 && (
          <path
            d={arc(fraction)}
            fill="none"
            stroke={count >= target ? '#327d75' : '#f85f2a'}
            strokeWidth={16}
            strokeLinecap="round"
          />
        )}
        <text x={CENTER_X} y={CENTER_Y - 14} textAnchor="middle" fontSize="28" fontWeight="700">
          {percent.toLocaleString(locale)}%
        </text>
        <text x={CENTER_X} y={CENTER_Y + 6} textAnchor="middle" fontSize="11">
          {t('{count} of {target} corrected', {
            count: count.toLocaleString(locale),
            target: target.toLocaleString(locale),
          })}
        </text>
      </svg>
    </div>
  );
}
